import React from 'react';
import { useCurrentWidth } from '@fff-web/fff-ui-shared/hooks';
import { getImagesStaticUrl } from '../../helpers';
import LockInCTA from '../../components/LockInCTA';
import Layout from '../../components/Layout';
import breakpoints from '../../utils/breakpoints';

import styles from './LockInRate.module.scss';

const LockInRate = ({
  lockedRateStatus,
  subscriptionState,
  lockedRateStatusMessage,
  handlePurchase,
  buttonClicked,
}) => {
  const currentWidth = useCurrentWidth();

  const boxImage = () => {
    let boxImageName = 'lock-in-rate-mobile-short.jpg';
    const displayMobileLarge = currentWidth > 377 && currentWidth <= 511;
    if (displayMobileLarge) boxImageName = 'lock-in-rate-mobile-large.jpg';
    if (currentWidth > breakpoints.medium) boxImageName = 'lock-in-rate-desktop.jpg';

    return (
      <div className={styles.lirBoxContainer}>
        <img alt="" className={styles.lirBoxImage} src={getImagesStaticUrl(boxImageName)} />
      </div>
    );
  };

  return (
    <Layout
      redirectIfNoAuth
      meta={{
        metadata: [
          {
            name: 'description',
            content: 'Lock in your rate',
          },
        ],
      }}
    >
      <div className={styles.lirContainer}>
        <div className={styles.lirHeroWrapper}>
          <img
            alt=""
            className={styles.lirHero}
            src={getImagesStaticUrl('lock-in-rate-hero.jpg')}
          />
        </div>
        <div className={styles.lirContentWrapper}>
          {boxImage()}
          <p className={styles.lirOffer}>LIMITED TIME OFFER</p>
          <h1 className={styles.lirTitle}>Lock in Your Rate</h1>
          <p className={styles.lirDescription}>
            The annual membership will increase to $219.99 ($54.99 per box) on Oct 19, 2022. Lock in
            your current price of $199.99 ($49.99 per box) for an additional four boxes!{' '}
            <b>Hurry, this offer ends Oct 18, 2022</b>
          </p>
          <p className={styles.lirLegalNote}>
            By clicking &quot;Purchase Now&quot; you agree to be immediately charged $199.99 USD
            (plus shipping and taxes, if applicable) for an additional 4 boxes. These boxes will be
            in addition to any remaining boxes you have on your account. Your subscription will
            continue indefinitely until canceled and on your next bill date, you will be charged
            $219.99 USD (plus shipping and taxes, if applicable) to the payment method on file. You
            can view your next billing season on your account page. Foreign exchange or transaction
            fees may apply for non-US customers. Cancel anytime online before your next bill date.
            <br />
            <br />
            You are also agreeing to our{' '}
            <a
              href={`${process.env.REACT_APP_LEGAL_URL}/#terms-of-use`}
              className={styles.lirLegalNoteLinks}
            >
              Terms of Use and Sale
            </a>{' '}
            and{' '}
            <a
              href={`${process.env.REACT_APP_LEGAL_URL}/#box-membership-terms`}
              className={styles.lirLegalNoteLinks}
            >
              FabFitFun Membership Terms
            </a>
            .
          </p>
          <LockInCTA
            lockedRateStatus={lockedRateStatus}
            subscriptionState={subscriptionState}
            lockedRateStatusMessage={lockedRateStatusMessage}
            handlePurchase={handlePurchase}
            buttonClicked={buttonClicked}
          />
        </div>
      </div>
    </Layout>
  );
};

export default LockInRate;
